/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useState } from 'react';

import { BrandingUiInfoKeys } from '../../../../../core/entities';
import { ServicesClientImpl } from '../../../../../core/interactors';

import './ImageItem.scss';

interface PosterImageItemProps {
    image: string;
    type: 'PosterImage' | 'LandscapeImage';
    value?: string;
    layout: 'upcoming-airing' | 'all-upcoming-episodes' | 'all-episodes';
    title?: string;
    isHighlighted?: boolean;
}

const ImageItem: FunctionComponent<PosterImageItemProps> = ({
    value,
    image,
    type,
    layout,
    title,
    isHighlighted,
}) => {
    const services = new ServicesClientImpl();
    const DEFAULT_IMAGE = services.getAppUiImageByKey(
        BrandingUiInfoKeys.APP_ICONS.DEFAULT_BACKGROUND,
    );
    const imageClass = type === 'PosterImage' ? 'poster' : 'landscape';

    let viewAllClass = '';
    if (value === 'view-all') {
        if (isHighlighted) {
            viewAllClass = 'view-all-highlighted';
        } else {
            viewAllClass = 'view-all-unhighlighted';
        }
    }

    const [hasError, setHasError] = useState(false);

    return (
        <React.Fragment>
            <img
                src={image || DEFAULT_IMAGE?.imageUrl}
                loading="lazy"
                className={`image-item ${imageClass} ${layout} ${viewAllClass}`.trim()}
                onLoad={(e) => {
                    if (new URL(e.currentTarget.src).pathname !== DEFAULT_IMAGE?.imageUrl)
                        setHasError(false);
                }}
                onError={(e) => {
                    e.currentTarget.src = DEFAULT_IMAGE?.imageUrl || '';
                    setHasError(true);
                }}
            />
            {hasError && <span className="fallback-image-text">{title}</span>}
            {value === 'view-all' && <span className="view-all-line"></span>}
        </React.Fragment>
    );
};

export default ImageItem;
